module.exports = __webpack_public_path__ + "media/images/pc/brands/aqua/store_fuji-d499a94abdc3a1b24996762bb3778bc0.jpg";